import type { SearchQuery } from '../hooks/useSharedJobPosts';

// SharedJobPostSyncRequest::SEARCH_CONDITIONS_SCHEMA が受け付ける検索条件だけを送る。それ以外の既定値（空配列や *_undisclosed='1'）で同期ボタンが常時表示されていた
const SYNC_REQUEST_CONDITION_KEYS = [
  'search_query',
  'company_name',
  'job_position_name',
  'min_salary',
  'max_salary',
  'salary',
  'salary_undisclosed',
] as const satisfies ReadonlyArray<keyof SearchQuery>;

export type SyncRequestSearchConditions = Pick<
  SearchQuery,
  (typeof SYNC_REQUEST_CONDITION_KEYS)[number]
> & {
  // フォーム入力は廃止済みだが、保存済み同期リクエストの検索条件表示のため型のみ残す（Issue #3397）
  working_location?: string;
};

export default function pickSyncRequestSearchConditions(
  searchQuery: SearchQuery
): SyncRequestSearchConditions {
  return Object.fromEntries(
    SYNC_REQUEST_CONDITION_KEYS.map((key) => [key, searchQuery[key]])
  ) as SyncRequestSearchConditions;
}
